import { z } from 'zod';

const canonicalUuidPattern =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const wittyUuidZod = z
  .string()
  .regex(canonicalUuidPattern, 'Invalid Witty UUID');

export const wittyAgentIdZod = wittyUuidZod;

export const mcpToolReferenceZod = z.object({
  server: z.string().min(1),
  name: z.string().min(1),
});

export type McpToolReference = z.infer<typeof mcpToolReferenceZod>;

export const mcpToolReferenceToId = ({ server, name }: McpToolReference) =>
  `${server}:${name}`;

export const paginationZod = z.object({
  total: z.number().int().nonnegative(),
  limit: z.number().int().positive(),
  offset: z.number().int().nonnegative(),
});

export const paginatedResponseZod = <T extends z.ZodTypeAny>(dataZod: T) =>
  z.object({
    data: z.array(dataZod),
    meta: z.object({ pagination: paginationZod }),
  });

export type PaginationRequest = {
  limit?: number;
  offset?: number;
  search?: string;
};

export function toQueryString(
  parameters: Record<
    string,
    string | number | boolean | readonly string[] | undefined
  >,
): string {
  const searchParameters = new URLSearchParams();
  Object.entries(parameters).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach(item => searchParameters.append(key, item));
    } else if (value !== undefined && value !== '') {
      searchParameters.set(key, String(value));
    }
  });
  const query = searchParameters.toString();
  return query ? `?${query}` : '';
}
